import { useState } from 'react'

function HitlForm({ schema, onSubmit, onCancel }) {
  const [values, setValues] = useState(() => {
    const init = {}
    schema.fields.forEach((f) => {
      init[f.name] = ''
    })
    return init
  })
  const [submitted, setSubmitted] = useState(false)

  const handleChange = (name, value) => {
    setValues((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const missing = schema.fields
      .filter((f) => f.required && !values[f.name]?.trim())
      .map((f) => f.label)
    if (missing.length > 0) {
      return
    }
    setSubmitted(true)
    onSubmit(schema.type, values)
  }

  return (
    <div className="mt-2">
      <form onSubmit={handleSubmit} className="bg-soft-hi border border-soft-rule rounded-2xl rounded-bl-md p-4 flex flex-col gap-3">
        {schema.fields.map((field) => {
          if (field.type === 'hidden') return null

          const inputClasses =
            'w-full px-3 py-2 bg-soft-surface border border-soft-rule text-sm outline-none rounded'

          if (field.type === 'textarea') {
            return (
              <div key={field.name}>
                <label className="block text-xs text-soft-dim mb-1">
                  {field.label}{field.required ? ' *' : ''}
                </label>
                <textarea
                  value={values[field.name]}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  placeholder={field.label}
                  className={`${inputClasses} resize-none`}
                  rows={3}
                  required={field.required}
                />
              </div>
            )
          }

          return (
            <div key={field.name}>
              <label className="block text-xs text-soft-dim mb-1">
                {field.label}{field.required ? ' *' : ''}
              </label>
              <input
                type={field.type}
                value={values[field.name]}
                onChange={(e) => handleChange(field.name, e.target.value)}
                placeholder={field.label}
                className={inputClasses}
                required={field.required}
              />
            </div>
          )
        })}

        <div className="flex gap-2 mt-1">
          <button
            type="submit"
            disabled={submitted}
            className="px-4 py-2 bg-soft-ink text-soft-bg text-sm cursor-pointer disabled:opacity-30"
          >
            {submitted ? 'Sending...' : 'Submit'}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-sm text-soft-dim cursor-pointer hover:text-soft-ink"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  )
}

export default HitlForm
